import { gql } from '@apollo/client'
import { META_FRAGMENT } from '../fragments/filters.fragment'
import { ABSTRACT_SEARCH_ITEM } from '../fragments/interface.fragment'
import { allContentFragments } from '../fragments/allContent.fragment'

export const GET_RECOMMENDED_CONTENT = gql`
  query GetRecommendedContent($input: RecommendedContentInput) {
    recommendedContent(input: $input) {
      meta {
        ...MetaNode
      }

      data {
        topic
        count
        data {
          ...AllContentItemNode
        }
      }
    }
  }
  ${allContentFragments.fragments.node}
  ${ABSTRACT_SEARCH_ITEM}
  ${META_FRAGMENT}
`
